var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 142,
    height: 133,
    viewBox: "0 0 142 133",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4681_2457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.92 9.17C23.35 6.26 23.92 2.77 26.09 0.5C25.33 0.64 24.58 0.89 23.87 1.27C20.24 3.22 18.89 7.74 20.84 11.37C22.79 15 27.31 16.35 30.94 14.4C31.65 14.02 32.28 13.53 32.81 12.97C29.72 13.52 26.5 12.08 24.93 9.16L24.92 9.17Z",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.64 110.41H37.86",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.04 110.41H41.7",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.07 110.41H62.72",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.68 112.36H61.34",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.64 107.39H36.78",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.64 104.37H39.17",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.74 58.04H59.94",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.43 54.04H56.96",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.92 44.46H53.02",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.87 44.46H58.41",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.96 54.04H60.92",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.74 50.04H55.46",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.87 50.04H58.96",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.44 88.8301H54.47",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.54 84.8301H63.16",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.43 80.8301H60.63",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.36 92.6499H60.51",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.47 76.8301H59.26",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.37 88.8301H62.15",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.09 96.47H61.9",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.14 96.47H67.57",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.51 100.29H65.04",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.96 72.8301H61.56",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.21 68.8301H54.87",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.96 68.8301H60.63",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.53 64.8301H58.79",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.66 131.57H129.69",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.05 131.57H139.35",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.83 126.91H135.85",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.87 122.91H104.94",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.21 118.95H123.76",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.8 118.95H140.81",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.49 122.91H111.07",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.86 122.91H128.56",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.34 118.91H108.04",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.87 114.91H127.34",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.38 114.91H12.66",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.12 110.91H113.86",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.19 110.91H29.93",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 110.91H7.08",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.75 106.91H104.32",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.01 106.91H118.26",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.39 110.91H129.21",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.06 114.91H134.45",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.86 106.91H121.76",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.17 118.95H111.07",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.49 114.91H95.39",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.98 106.91H23.88",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.19 110.91H14.09",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.91 106.91H19.47",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.35 122.91H137.25",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.25 122.91H133.15",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.01 106.91H138.99",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.34 115.25H84.89",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.48 106.91H33.76",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.81 106.91H14.09",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.95 118.95H33.99",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.15 118.95H49.91",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.19 124.68H66.95",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.69 118.95H52.69",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.52 118.95H59.2",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.44 124.68H75.58",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.73 113.59V109.16C56.73 107.91 55.72 106.91 54.48 106.91C53.23 106.91 52.23 107.92 52.23 109.16V112.93",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.48 75.6499L51.42 31.8999H70.88L78.99 120.22",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.07 47.1599H73.9",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.56 60.75H75.57",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.54 19.1499H52.43V31.8999H69.54V19.1499Z",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.98 19.1499V31.8999",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.01 19.1499V31.8999",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.96 19.1499V31.8999",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.43 23.6799H69.54",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.85 19.1499H71.99L60.92 11.4399L49.85 19.1499Z",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.52 96.47L46.56 103.51H63.16L56.96 96.47H40.52Z",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.65 113.41V103.51L40.52 96.47L46.56 103.51V112.91",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.16 103.51V115.25",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9 37.76H48.07V41.77H73.9V37.76Z",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.02 28.24H49.82V31.9H72.02V28.24Z",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 119.3C0.5 119.3 28.65 113.4 34.65 113.4C40.65 113.4 47.94 112.9 51.52 112.9C55.1 112.9 60.01 114.33 63.16 115.25C65.99 116.07 72.51 119.58 80.42 120.62C98.18 122.94 97.04 130.6 123.75 131.57",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.94 33.2501L69.54 25.5201V22.5601L117.94 14.8301",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.43 37.76V41.77",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.87 37.76V41.77",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.32 37.76V41.77",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.76 37.76V41.77",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2 37.76V41.77",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.65 37.76V41.77",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.09 37.76V41.77",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.54 37.76V41.77",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.24 119.3C74.24 119.3 79.51 121.14 83.12 124.18C86.73 127.22 91.62 129.94 92.38 130.04",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.56 74.1301C38.56 74.1301 42.57 72.2801 43.99 76.5701C43.99 76.5701 49.17 73.5401 51.68 78.2501C52.9 80.5301 52.11 84.0601 48.4 84.7201",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.39 78.3601C19.94 77.2701 19.83 82.1101 19.83 82.1101C16.79 82.0601 14.35 84.3401 13.75 87.2201C13.15 90.1001 15.22 92.3201 15.22 92.3201C14.3 94.1101 15.06 96.1801 17.12 96.2301C19.18 96.2801 19.83 93.1301 19.83 93.1301C19.83 93.1301 20.96 94.3601 23.67 92.9101",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.39 80.53C24.39 80.53 25.15 72.33 32.48 76.51",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.48 78.4701C32.48 78.4701 32.52 76.4101 33.26 75.0601C34.09 73.5401 37.1 72.3301 39.49 75.4801",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.13 102.36C35.13 102.36 33.62 100.08 33.62 97.8499C33.62 95.6199 37.53 93.3999 37.58 89.6499",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.65 108.01C34.65 108.01 31.61 104.59 30.52 101.33C29.43 98.0699 29.71 97.1499 29.38 94.9199C29.05 92.6899 26.99 92.0999 24.66 92.8599C22.33 93.6199 23.09 90.3599 22.49 89.1699",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6 80.53C40.6 80.53 40.69 83.83 38.19 84.64C36.7 85.13 35.79 88.75 35.79 88.75",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.59 90.81C37.59 90.81 44.17 93.35 47.32 89.87C49.3 87.69 49.01 85.42 48.4 84.71",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.63 83.74C23.63 83.74 22.65 87 24.99 87.6C27.33 88.2 31.99 88.79 31.99 93.79C31.99 93.79 35.19 87.76 33.18 84.02",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.99 99.65C31.99 99.65 31.28 97.32 31.99 93.79",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.58 90.53H46.12",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.56 90.97H20.83",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.06 94.05H16.91",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2 87.96H48.53",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.75 87.96H41.92",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.35 87.96H33.08",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4 84.9399H45.91",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9 84.9399H31.68",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.44 84.9399H28.27",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.24 81.9199H51.68",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.91 81.9199H48",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.29 81.9199H43.21",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.12 90.8401L45.61 96.4701",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.58 131.08C96.11 131.24 97.86 131.57 97.86 131.57",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.94 25.5201L22.87 24.82L22.22 23.8L21.55 24.82L20.5 25.5201L21.59 26.14L22.21 27.08L22.86 26.07L23.94 25.5201Z",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.31 48.2801L88.24 47.5801L87.59 46.5601L86.93 47.5801L85.87 48.2801L86.97 48.8901L87.58 49.8301L88.23 48.8301L89.31 48.2801Z",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.24 52.49L41.17 51.79L40.52 50.77L39.86 51.79L38.8 52.49L39.9 53.11L40.51 54.04L41.16 53.04L42.24 52.49Z",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.78 5.44012L51.27 5.11012L50.96 4.62012L50.64 5.11012L50.14 5.44012L50.66 5.73012L50.95 6.17012L51.26 5.70012L51.78 5.44012Z",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8 35.6401L79.3 35.3101L78.99 34.8201L78.67 35.3101L78.17 35.6401L78.69 35.9301L78.98 36.3701L79.29 35.9001L79.8 35.6401Z",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.09 60.0099L28.58 59.68L28.27 59.2L27.96 59.68L27.46 60.0099L27.98 60.2999L28.27 60.75L28.57 60.27L29.09 60.0099Z",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.28 44.4999L132.78 44.1699L132.47 43.6899L132.15 44.1699L131.65 44.4999L132.17 44.7999L132.46 45.2399L132.77 44.7599L133.28 44.4999Z",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.89 80.1201L111.38 79.7901L111.07 79.3101L110.75 79.7901L110.25 80.1201L110.77 80.4101L111.06 80.8601L111.37 80.3801L111.89 80.1201Z",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.01 7.94012L97.5 7.61012L97.19 7.12012L96.88 7.61012L96.38 7.94012L96.9 8.23012L97.19 8.67012L97.5 8.20012L98.01 7.94012Z",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.44 6.4301L106.38 6.4001L106.35 6.3501L106.32 6.4001L106.27 6.4301L106.32 6.4601L106.35 6.5101L106.38 6.4601L106.44 6.4301Z",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.65 26.6501L38.6 26.6201L38.56 26.5701L38.53 26.6201L38.48 26.6501L38.53 26.6801L38.56 26.7301L38.59 26.6801L38.65 26.6501Z",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.53 63.81L119.48 63.77L119.44 63.72L119.41 63.77L119.36 63.81L119.41 63.84L119.44 63.88L119.47 63.84L119.53 63.81Z",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.57 40.6L107.52 40.57L107.49 40.52L107.45 40.57L107.4 40.6L107.46 40.63L107.49 40.68L107.52 40.63L107.57 40.6Z",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.94 74.4799L97.89 74.4499L97.86 74.3999L97.82 74.4499L97.77 74.4799L97.83 74.5099L97.86 74.5599L97.89 74.5099L97.94 74.4799Z",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.75 58.05L10.7 58.01L10.67 57.96L10.64 58.01L10.59 58.05L10.64 58.08L10.67 58.12L10.7 58.07L10.75 58.05Z",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.24 33.8401C9.36998 33.8401 7.85999 35.3501 7.85999 37.2201C7.85999 39.0901 9.36998 40.6001 11.24 40.6001H14.86",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.67001 47.16C7.37001 47.16 6.32001 46.11 6.32001 44.81C6.32001 43.51 7.37001 42.46 8.67001 42.46H12.09",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.49 40.6001H19.1",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.05 42.47H26.37",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.38 40.6001H23.41",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.89 42.47H29.63",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65002 44.8101H15.92",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.97998 37.2201C9.97998 36.4601 10.6 35.8401 11.36 35.8401",
    stroke: "#B8C1CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4681_2457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 141.31,
    height: 132.07,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/empty-state.6c65396af11a209051b367547a4d1e29.svg";
export { ForwardRef as ReactComponent };